import { render } from "./OperationFeedbackHost.vue?vue&type=template&id=0edbd3cf&scoped=true&ts=true"
import script from "./OperationFeedbackHost.vue?vue&type=script&lang=ts"
export * from "./OperationFeedbackHost.vue?vue&type=script&lang=ts"

import "./OperationFeedbackHost.vue?vue&type=style&index=0&id=0edbd3cf&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edbd3cf"]])

export default __exports__